const filter = {
  state: {
    filterList: null,
    orderInvoiceFilter: null, // 발주입고 필터
    orderFilter: null, // 발주 필터
    invoiceFilter: null, // 출고 필터
    storeFilter: null, // 입고 필터
  },
  mutations: {
    setFilter(state, payload) {
      state.filterList = payload;
    },
    setOrderInvoiceFilter(state, payload) {
      state.orderInvoiceFilter = payload;
    },
    setOrderFilter(state, payload) {
      state.orderFilter = payload;
    },
    setInvoiceFilter(state, payload) {
      state.invoiceFilter = payload;
    },
    setStoreFilter(state, payload) {
      state.storeFilter = payload;
    },
    resetStoreFilter(state) {
      state.filterList = null;
      state.orderInvoiceFilter = null;
      state.orderFilter = null;
      state.invoiceFilter = null;
      state.storeFilter = null;
    },
  },
  getters: {
    getFilter(state) {
      return state.filterList;
    },
    getOrderInvoiceFilter(state) {
      return state.orderInvoiceFilter;
    },
    getOrderFilter(state) {
      return state.orderFilter;
    },
    getInvoiceFilter(state) {
      return state.invoiceFilter;
    },
    getStoreFilter(state) {
      return state.storeFilter;
    },
  },
  actions: {},
};
export default filter;
